// https://github.com/M-Ulyanov/SlidingMenu
// Footer Sliding Menu
var footerSlidingMenu = function() {

  var $footerMenuLineHover = $(".footer__metaNav[data-line-hover]");
  var $items = $footerMenuLineHover.find(".menu__item");
  // eslint-disable-next-line
  new SlidingMenu({
    menu: $footerMenuLineHover,
    items: $items,
    duration: 0,
    slidingClass: "type-line"
  });

};
// eslint-disable-next-line
export {footerSlidingMenu};